import { ElementTypes } from '../types'

export const createParagraphNode = (children = [{ text: '' }]) => ({
  type: ElementTypes.PARAGRAPH,
  children,
})
